import React, { useCallback, useState } from "react";
import { MessagesCard } from "./MessagesCard";
import { InboxCards } from "./inboxCards";

export const Inbox = ({ onSelected, selectedSeeker, seekersList }) => {
  const [searchText, setSearchText] = useState("");

  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const SelectSeeker = (seeker) => {
    onSelected(seeker);
  };

  const searchFilter = useCallback(
    (seeker) => {
      return (
        seeker.email.toLowerCase()?.indexOf(searchText.toLocaleLowerCase()) >
          -1 ||
        seeker.firstName
          .toLowerCase()
          ?.indexOf(searchText.toLocaleLowerCase()) > -1 ||
        seeker.lastName.toLowerCase()?.indexOf(searchText.toLocaleLowerCase()) >
          -1
      );
    },
    [searchText]
  );

  return (
    <MessagesCard>
      <div className="d-flex flex-column w-100">
        <div className="form-group fv-plugins-icon-container d-flex">
          <input
            placeholder="Search"
            type="email"
            className="form-control form-control-solid h-auto py-4 px-3"
            name="email"
            value={searchText}
            onChange={(e) => handleChange(e)}
          />
          {/* <div
            className="btn btn-primary d-flex align-items-center ml-3"
            onClick={() => alert("coming soon")}
          >
            <p className="m-0">
              <b>Add</b>
            </p>
          </div> */}
        </div>
        <div className="mt-1 overflow-auto" style={{ height: "50vh" }}>
          {seekersList &&
            !!seekersList.length &&
            seekersList.map(
              ({ seeker, latestMessage, unReadCount }) =>
                searchFilter(seeker) && (
                  <InboxCards
                    seeker={seeker}
                    onSelected={SelectSeeker}
                    unreadCount={unReadCount}
                    latestMessage={latestMessage}
                    isActive={seeker.id === selectedSeeker?.id}
                    key={seeker.id}
                  />
                )
            )}
        </div>
      </div>
    </MessagesCard>
  );
};
